import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { ShieldOff } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Forbidden: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '70vh',
                gap: 2,
                textAlign: 'center',
                px: 3,
            }}
        >
            <Box
                sx={{
                    width: 96,
                    height: 96,
                    borderRadius: '50%',
                    background: '#fdecea',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <ShieldOff size={44} color="#e53e3e" />
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                You don't have access to this page
            </Typography>
            <Typography variant="body2" sx={{ color: 'var(--color-text-muted)', maxWidth: 420 }}>
                Your role doesn't include permission to view this section. If you think this is a mistake, ask an admin to update your access under Settings &gt; User Security.
            </Typography>
            <Button
                variant="contained"
                onClick={() => navigate('/transaction')}
                sx={{ background: 'var(--color-primary)', color: '#fff', boxShadow: 'none', borderRadius: 2, fontWeight: 600, textTransform: 'none', mt: 1, '&:hover': { background: 'var(--color-primary)' } }}
            >
                Back to Dashboard
            </Button>
        </Box>
    );
};

export default Forbidden;
